import * as actionTypes from './actionTypes';
import { UserModel } from '@app/src/views/Login/login/models/User';
import * as actionTypesSidebar from '@app/src/commons/sidebar/state/sidebar/actionTypes';
import { decodeAccessToken } from '@app/src/helpers/decodeAccessToken';

interface State {
  data: UserModel;
  errorMessage: string;
  isFetching: boolean;
  isResending: boolean;
  errorRol: boolean;
  msgType: 'info' | 'error' | null;
}

const initialState: State = {
  data: {
    code: null,
    message: '',
    user: {
      id: Number(decodeAccessToken('idUser')) || null,
      username: decodeAccessToken('username') || '',
      alias: decodeAccessToken('alias') || '',
      isAdmin: Boolean(decodeAccessToken('isAdmin')) || false,
      reportToken: sessionStorage.getItem('reportToken') || '',
      accessToken: sessionStorage.getItem('accessToken') || '',
      service: {
        id: Number(decodeAccessToken('idService')) || null,
        name: decodeAccessToken('service') || '',
        idCountry: Number(decodeAccessToken('idCountry')) || null,
        dateCreated: decodeAccessToken('dateCreated') || ''
      }
    }
  },
  errorMessage: '',
  isFetching: false,
  isResending: false,
  errorRol: false,
  msgType: null
};

export const userOdt = (state: State = initialState, action): State => {
  switch(action.type) {
    case actionTypes.FETCH_LOGIN_MFA_REQUEST:
      return {
        ...state,
        isFetching: true,
        isResending: false
      };

    case actionTypes.FETCH_LOGIN_MFA_RESEND_REQUEST:
      return {
        ...state,
        isFetching: false,
        isResending: true
      };
    case actionTypes.FETCH_LOGIN_MFA_SESSION_TOKEN_ERROR:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.errorMessage,
        errorRol: action.errorRol,
        msgType: action.msgType
      };
    case actionTypes.FETCH_LOGIN_MFA_OTP_ERROR:
      return {
        ...state,
        errorMessage: action.errorMessage,
        isFetching: false,
        msgType: action.msgType
      };
    case actionTypes.FETCH_LOGIN_MFA_EXCEEDED_OTP_ATTEMPTS_ERROR:
      return {
        ...state,
        errorMessage: action.errorMessage,
        isFetching: false,
        msgType: action.msgType
      };
    case actionTypesSidebar.RESET_APP_STATE:
      return initialState;
    default:
      return state;
  }
}
